import React, { createContext, useContext, useEffect, useState } from 'react';

// Crear el contexto
const UserContext = createContext();

// Hook personalizado para acceder al contexto
export const useUser = () => useContext(UserContext);

// Provider del contexto
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Cargar usuario/token desde localStorage al iniciar
  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (savedToken && savedUser) {
      try {
        setToken(savedToken);
        setUser(JSON.parse(savedUser));
      } catch (e) {
        console.error('Error al parsear usuario:', e);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }

    setIsLoading(false);
  }, []);

  const login = (token, userData) => {
    setToken(token);
    setUser(userData);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const hasPermission = (perm) => {
    return user?.permissions?.includes(perm) || false;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        token,
        login,
        logout,
        isLoading,
        hasPermission,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
